import { NgModule, ModuleWithProviders, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DataService } from './data.service';
import { Util } from './util.service';

import { WizdomErrorHandler } from './app-error.handler';
import { APP_CONFIG, WIZDOM_APP_CONFIG } from './app.config';

import { AuthGuardGuard } from './auth-guard.guard';
import { SortingresultsService } from './sorting.results.service';
import { NotificationRouteService } from './notification-route.service';
import { SharingPanelService } from './sharing-panel-service';
import { DynamicFieldService } from '../shared-components/dynamic-field/dynamic-field.service';
import { DynamicFieldLearningService } from '../shared-components/dynamic-field-learning/dynamic-field-learning.service';
import { ViewMoreLikeThisService } from '../shared-components/view-more-like-this/view-more-like-this.service';
import { SuggestionsService } from '../shared-components/suggestions/suggestions.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  exports: []
})
export class SharedServiceModule {
  constructor (@Optional() @SkipSelf() parentModule: SharedServiceModule) {
    if (parentModule) {
      throw new Error(
        'SharedServiceModule is already loaded. Import it in the AppModule only');
    }
  }
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: SharedServiceModule,
      providers: [        
        DataService,
        Util,
        WizdomErrorHandler,
        AuthGuardGuard,
        SortingresultsService,
        NotificationRouteService,
        SharingPanelService,
        DynamicFieldService,
        DynamicFieldLearningService,
        ViewMoreLikeThisService,
        SuggestionsService,
        { provide: APP_CONFIG, useValue: WIZDOM_APP_CONFIG }
      ]
    }
  }
}
